'use client';

import type { QueryParams } from '@/lib/api/httpClient';
import { createHttpClient } from '@/lib/api/httpClient';
import {
  mapFullUserBalanceListResponse,
  mapUserBalanceListResponse,
} from '@/lib/api/user-balances/mappers';
import type { FullUserBalancesResult, UserBalancesResult } from '@/lib/api/user-balances/models';
import type {
  FullUserBalanceListResponse,
  FullUserBalancesQueryParams,
  UserBalanceListResponse,
  UserBalancesQueryParams,
} from '@/lib/api/user-balances/types';

const walletHttp = createHttpClient({ baseUrl: process.env.NEXT_PUBLIC_API_WALLET_URL });

export async function fetchUserBalances(
  params: UserBalancesQueryParams,
): Promise<UserBalancesResult> {
  const response = await walletHttp.get<UserBalanceListResponse>('/user-balances', {
    query: (params as unknown as QueryParams) ?? undefined,
  });

  if (!response) {
    return {
      balances: [],
      page: 0,
      size: 0,
      totalPages: 0,
    };
  }

  return mapUserBalanceListResponse(response);
}

export async function fetchFullUserBalances(
  params: FullUserBalancesQueryParams,
): Promise<FullUserBalancesResult> {
  const response = await walletHttp.get<FullUserBalanceListResponse>('/user-balances/full', {
    query: (params as unknown as QueryParams) ?? undefined,
  });

  if (!response) {
    return {
      balances: [],
      page: 0,
      size: 0,
      totalPages: 0,
    };
  }

  return mapFullUserBalanceListResponse(response);
}
